import { useEffect } from "react";
import { observer } from "mobx-react";

import DetailPane from "./Panes/Detail";
import ProfileHeader from "./ProfileHeader";
import SubjectIndex from "../SubjectIndex";
import useStores from "../../../../utils/useStores";

import "./Profile.css";

const Profile = observer(() => {
    const rootStore = useStores();

    useEffect(() => {
        rootStore.profileStore.fetchProfile();
    }, [rootStore]);

    const { profile } = rootStore.profileStore;

    let gravWidth = 150;
    if (screen.width < 400) {
        gravWidth = 100;
    }

    const gravatar_url =
        profile.gravatar_url ||
        `https://www.gravatar.com/avatar/000000000000000000000000.jpg?size=${gravWidth}px`;

    const header = (
        <ProfileHeader
            gravatar={gravatar_url}
            username={profile.username}
            name={profile.name}
            age={profile.age}
            quote={profile.quote}
        />
    );

    const shownPanes = (
        <div className="row">
            <div className="col-md-6 data-block">
                <DetailPane rootStore={rootStore} />
            </div>
        </div>
    );

    return (
        <div className="container foreground">
            <div className="Profile">
                <SubjectIndex rootStore={rootStore} />
                {shownPanes}
            </div>
        </div>
    );
});

export default Profile;